<template>
  <div>
    <vx-card id="queueDataContainer" :title="$t('queues')" class="mb-8" :collapse-action="false">
      <template slot="actions">
        <vs-switch class="mr-2" @click="changeStatus" :value="queueReportStatus">
          <span slot="on" />
          <span slot="off" />
        </vs-switch>
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" @click="openModifyQueuePopup" v-if="$store.getters.hasCompanyPermission('company_can_modify_queue')">{{ $t('modify_queue') }}</vs-button>
        <vs-button v-if="$store.getters.hasCompanyPermission('company_can_use_queue_all')" color="primary" type="filled" size="small" @click.prevent="$router.push(`/window/queue-all?queues=${ queues.map(item => item.number).join(',') }`)">
          {{ $t('queue_status_all') }}
        </vs-button>
      </template>
      <div class="vx-row">
        <div class="vx-col w-full">
          <shared-queue-list :queues="queues"></shared-queue-list>
        </div>
      </div>
    </vx-card>
    <vx-card id="queueReportDataContainer" :title="$t('queue_report')" class="mb-8" :collapse-action="false">
      <div class="vx-row">
        <div class="vx-col w-full">
          <shared-queue-report-list :queues="queues"></shared-queue-report-list>
        </div>
      </div>
    </vx-card>
    <vx-card v-if="$store.getters.hasCompanyPermission('ob_queue_status')" id="obQueueStatusDataContainer" :title="$t('ob_queue_status')" class="mb-8" :collapse-action="false">
      <div class="vx-row">
        <div class="vx-col w-full">
          <shared-ob-queue-status-list :queues="queues"></shared-ob-queue-status-list>
        </div>
      </div>
    </vx-card>
    <vx-card id="queue_history" :title="$t('queue_history')" class="mb-8" :collapse-action="false" v-if="this.$store.getters.hasCompanyPermission('company_can_use_queue_history')">
      <div class="vx-row queue-history" >
        <div class="vx-col w-full mb-5">
          <div class="vx-row">
            <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
              <date-picker v-model="queueHistorySearchParams.date" :model="queueHistorySearchParams.date" value-type="format" format="YYYY-MM-DD" :placeholder="$t('date')" class="w-full" :append-to-body="false"></date-picker>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
              <vs-input v-model="queueHistorySearchParams.queue_number" :model="queueHistorySearchParams.queue_number" :placeholder="$tc('queue_number')" class="w-full"/>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
              <v-select :options="timeOptions" :reduce="label => label.value" :placeholder="$t('all')" v-model="queueHistorySearchParams.time" class="mb-3" />
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-button color="success" type="filled" class="w-full" @click.prevent="searchQueueHistory()" v-text="$t('search')"></vs-button>
            </div>
          </div>
        </div>
        <div class="vx-col md:w-2/12 sm:w-4/12 w-full mb-5">
          <ul class="box">
            <li @click.prevent="selectHistory('total')" :class="['total' == selectedHistory ? 'active' : '']" v-text="'Total'"></li>
            <li v-for="(item, key) in queues" :key="key" @click.prevent="selectHistory(item.number)" :class="[item.number == selectedHistory ? 'active' : '']" v-text="item.number"></li>
          </ul>
        </div>
        <div class="vx-col md:w-10/12 sm:w-8/12 w-full">
          <vs-table hover-flat v-if="queueHistory && queueHistory.length" :data="queueHistory">
            <template slot="thead">
              <vs-th v-text="$t('time')"></vs-th>
              <vs-th v-text="$t('total_incoming_call')"></vs-th>
              <vs-th v-text="$t('answered_call')"></vs-th>
              <vs-th v-text="$t('abandonment_issue')"></vs-th>
              <vs-th v-text="$t('response_rate')"></vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="key" v-for="(tr, key) in data">
                <vs-td v-text="tr.label"></vs-td>
                <vs-td v-text="tr.total_calls"></vs-td>
                <vs-td v-text="tr.answered_calls"></vs-td>
                <vs-td v-text="tr.dropped_calls"></vs-td>
                <vs-td v-text="tr.total_response_rate"></vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import Queue from '@/models/Queue'
import SharedQueueList from '@/views/Shared/Queues/List'
import SharedQueueReportList from '@/views/Shared/QueueReport/List'
import SharedObQueueStatusList from '@/views/Shared/ObQueueStatus/List'
// import DatePicker from '@/components/form-inputs/DatePicker'

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {EventBus} from '../../../eventbus'
import Modal from '@/components/Modal'
import User from '@/models/User'
import Utils from '@/helpers/utils'
import ctiWindow from '@/helpers/ctiWindow'

export default {
  name: 'User.Queues',
  components: {
    SharedQueueList,
    SharedQueueReportList,
    SharedObQueueStatusList,
    DatePicker,
    Modal
  },
  data () {
    return {
      companyId: this.$store.getters.userInfo.company.id,
      queueReportStatus: this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.queue_report_status !== null ? this.$store.getters.userInfo.queue_report_status : 0 : 0,
      queues: {},
      selectedHistory: 'total',
      queueHistories: {},
      queueHistory: {},
      timeOptions: [],
      queueHistorySearchParams: {
        date: typeof this.$route.query.date !== 'undefined' ? this.$route.query.date : '',
        queue_number: typeof this.$route.query.queue_number !== 'undefined' ? this.$route.query.queue_number : '',
        time: typeof this.$route.query.time !== 'undefined' ? this.$route.query.time : ''
      }
    }
  },
  mounted () {
    this.timeOptions = []
    let index = 0
    for (let i = 1; i <= 10; i++) {
      const label = (8 + i)
      this.timeOptions.push({
        label: `${label}:00`,
        value: index.toString()
      })
      index++
    }
    this.loadQueues()
    this.$windowOpenerHelper.listenToPopUpMessage('reload_queue_status_table', this.loadQueues)
  },
  methods: {
    modifyQueueModal () {
      EventBus.$emit('initModifyQueueFormData')
      this.modals.modifyQueue = true
    },
    openModifyQueuePopup () {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'modify-queue', {}, this.modifyQueueModal)
    },
    async changeStatus () {
      if (this.queueReportStatus === 1) {
        this.queueReportStatus = 0
      } else {
        this.queueReportStatus = 1
      }
      this.$store.dispatch('setUserQueueReportStatus', this.queueReportStatus)
      await User.updateQueueReportStatus({queueReportStatus: this.queueReportStatus})
    },
    async loadQueues () {
      this.$vs.loading({container: '#queueDataContainer'})

      const response = await Queue.all()
      this.queues = response.data.queues

      if (this.$store.getters.hasCompanyPermission('company_can_use_queue_history')) {
        this.$router.replace({ query: this.queueHistorySearchParams })
        const historyResponse = await Queue.history({...this.queueHistorySearchParams})
        this.queueHistories = historyResponse.data.result
        this.queueHistorySearchParams.date = historyResponse.data.queueHistory.dateQuery
        this.selectHistory(this.selectedHistory)
      }

      this.$vs.loading.close('#queueDataContainer > .con-vs-loading')
    },
    async searchQueueHistory () {
      this.$vs.loading({container: '#queue_history'})

      if (this.$store.getters.hasCompanyPermission('company_can_use_queue_history')) {
        this.$router.replace({ query: this.queueHistorySearchParams })
        const historyResponse = await Queue.history({...this.queueHistorySearchParams})
        this.queueHistories = historyResponse.data.result
        this.queueHistorySearchParams.date = historyResponse.data.queueHistory.dateQuery
        this.selectHistory(this.selectedHistory)
      }

      this.$vs.loading.close('#queue_history > .con-vs-loading')
    },
    selectHistory (index) {
      if(this.companyId == 72 && index == "5000") {
        ctiWindow.queueHistoryWindow({date: this.queueHistorySearchParams.date, queue_number: index, time: this.queueHistorySearchParams.time})
      } else {
        this.selectedHistory = index
        this.queueHistory = this.queueHistories[index]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
